module.exports = __webpack_public_path__ + "img/pennsylvania_applied.a1d26ea4.png";